import { css } from 'styled-components/macro';

export const webshopButtonCss = (disabled: boolean | undefined) => css`
  height: 32px;
  min-width: 187px;
  padding: 12px 24px;
  border-radius: 16px;
  color: #fff;
  background: #2e4063;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  border: 0;
  outline: 0;
  cursor: pointer;

  &:hover {
    opacity: ${disabled ? 'unset' : '0.7'};
  }
`;
